export default "__VITE_ASSET__qLCDA99c__"